import React from 'react'
import ScrollBox from '../../../components/ScrollBox'
import { Box, Grid, Stack, Tooltip, Typography } from '@mui/material'
import { makeTxtOverFLow } from '../../../utils/format'

function AttachBox({ files }) {

    function handleAttachClick(fileData) {
        window.open(fileData?.fileUrl, "_blank", "noopener,noreferrer");
    }

    return (
        files ? <Box sx={{ borderColor: "red", border: 1, height: 80, borderRadius: 1, color: "rgba(0,0,0,0.4)", pt: 0.5 }}>
            <ScrollBox pr={4} height={"93%"}>
                <Grid container
                    direction="row"
                    justifyContent="start"
                    alignItems="center"
                >
                    {(files || []).map((i, index) => (
                        <Stack direction={"row"} alignItems={"center"} gap={1} key={index} justifyContent={"center"}
                            onClick={() => handleAttachClick(i)} sx={{
                                height: 30, width: 150, border: 1, borderColor: "rgba(0,0,0,0.5)", borderRadius: 4, mx: 1,
                                mb: 1, bgcolor: "rgba(162, 214, 249, 0.18)",
                                cursor: "pointer", // Indicate clickability
                                transition: "transform 0.2s, background-color 0.2s",
                                "&:hover": {
                                    bgcolor: "rgba(162, 214, 249, 0.3)", // Change background color on hover
                                },
                                "&:active": {
                                    transform: "scale(0.95)", // Add scale effect on click
                                    bgcolor: "rgba(162, 214, 249, 0.5)", // Slightly darker background when clicked
                                },
                            }}  >
                            <Stack width={140} alignItems={"center"}>
                                <Tooltip title={i.fileName}>
                                    <Typography sx={{ fontSize: 12, color: "rgba(0,0,0,0.8)" }}>
                                        {makeTxtOverFLow(i.fileName, 17)}
                                    </Typography>
                                </Tooltip>
                            </Stack>
                        </Stack>

                    ))}
                </Grid>
            </ScrollBox>
        </Box> : <Typography sx={{ fontSize: 13 }}>NA</Typography>

    )
}

export default AttachBox